export default "__VITE_ASSET__Cm4A$Tww__"